import { render } from "./TeamStep.vue?vue&type=template&id=806b29c8&scoped=true"
import script from "./TeamStep.vue?vue&type=script&lang=js"
export * from "./TeamStep.vue?vue&type=script&lang=js"

import "./TeamStep.vue?vue&type=style&index=0&id=806b29c8&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-806b29c8"]])

export default __exports__